import React, { useEffect, useState, useContext, useRef } from "react";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import { useNavigate, useLocation } from "react-router-dom";
import { setSessionData, getSessionData } from "../../cache";
import Swal from "sweetalert2";
import "react-toastify/dist/ReactToastify.css";
import config from "../../config";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast, ToastContainer } from "react-toastify";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { FaRegFilePdf } from "react-icons/fa6";
import { ContextBoard } from "../../context/ContextBoard";

function StudentGenderChangeX() {
  const location = useLocation();
  const navigate = useNavigate();
  const permissions = JSON.parse(sessionStorage.getItem("permissions") || "[]");
  const photographRef = useRef();
  const signatureRef = useRef();
  const casteRef = useRef();
  const divyangRef = useRef();

  const [photoFile, setPhotoFile] = useState(null);
  const [signFile, setSignFile] = useState(null);
  const [casteFile, setCasteFile] = useState(null);
  const [divyangFile, setDivyangFile] = useState(null);

  const [photoBase64, setPhotoBase64] = useState("");
  const [photoName, setPhotoName] = useState("");
  const [photourl, setPhotourl] = useState("");

  const [signBase64, setSignBase64] = useState("");
  const [signName, setSignName] = useState("");
  const [signurl, setSignurl] = useState("");

  const [casteBase64, setCasteBase64] = useState("");
  const [casteName, setCasteName] = useState("");
  const [casteurl, setCasteurl] = useState("");

  const [divyangBase64, setDivyangBase64] = useState("");
  const [divyangName, setDivyangName] = useState("");
  const [divyangurl, setDivyangurl] = useState("");

  const [photooriginalname, setPhotooriginalname] = useState("");
  const [signoriginalname, setSignoriginalname] = useState("");

  const [showCropper, setShowCropper] = useState(false);
  const [cropperImage, setCropperImage] = useState("");
  const cropperRef = useRef(null);

  const [loading, setLoading] = useState(true);
  const [blockList, setBlockList] = useState([]);
  const [casteListnew, setCasteListnew] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [divyangList, setDivyangList] = useState([]);
  const [mediumList, setMediumList] = useState([]);
  const [religionList, setReligionList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [language1_2new, setLanguage1_2new] = useState([]);

  const [additional, setAdditional] = useState([]);
  const [compulsary, setCompulsary] = useState([]);
  const [compulsory_one, setCompulsoryOne] = useState("");
  const [compulsory_two, setCompulsoryTwo] = useState("");
  const [compulsory_three, setCompulsoryThree] = useState("");

  const [errors, setErrors] = useState({});
  const [isPreviewed, setIsPreviewed] = useState(false);
  const [isAgreed, setIsAgreed] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  const [finaledit, setFinaledit] = useState(false);

  const [olddivyangFile, setOlddivyangFile] = useState(null);

  const [formData, setFormData] = useState({
    passingyear: "",
    roll_code: "",
    roll_number: "",
    registration_number: "",
    candidate_name: "",
    gender: "",
    date_of_birth: "",
    fathers_name: "",
    mothers_name: "",
    religion: "",
    nationality: "Indian",
    aadhaar_no: "",
    divyang_val: "",
    caste_val: "",
    area: "",
    state_val: "",
    district_val: "",
    block_val: "",
    address_val: "",
    pin_no: "",
    contact_no: "",
    email_id: "",
    category_choice: "",
    board_name: "JAC",
    examination_medium: "",
    language_one: "",
    language_two: "",
    compulsory_one: "",
    compulsory_two: "",
    compulsory_three: "",
    additional_subject: "",
    apaar_id: "",
    pen_no: "",
    language_one_name: "",
    language_two_name: "",
    compulsory_one_name: "",
    compulsory_two_name: "",
    compulsory_three_name: "",
    additional_subject_name: "",
  });
  const { state } = useLocation();
  const candidateData = state?.studentData || null;
  useEffect(() => {
    if (!permissions[9]?.caN_VIEW) {
      navigate("/secondary-admin-dashboard");
    }
  }, [permissions, navigate]);
  useEffect(() => {
    if (candidateData === null) {
      navigate("/secondary-Gender-details-update");
      return;
    }
    // 🔹 Read session lists
    const blockList = getSessionData("blockList") || [];
    const casteList = getSessionData("casteList") || [];
    const districtList = getSessionData("districtList") || [];
    const divyangList = getSessionData("divyangList") || [];
    const mediumList = getSessionData("mediumList") || [];
    const religionList = getSessionData("religionList") || [];
    const stateList = getSessionData("stateList") || [];
    const language1_2 = getSessionData("language1_2") || [];
    const additional = getSessionData("additional") || [];
    const compulsary = getSessionData("compulsary") || [];
    const compulsory_one = getSessionData("compulsory_one") || [];
    const compulsory_two = getSessionData("compulsory_two") || [];
    const compulsory_three = getSessionData("compulsory_three") || [];

    // 🔹 Set lists
    setBlockList(blockList);
    setCasteListnew(casteList);
    setDistrictList(districtList);
    setDivyangList(divyangList);
    setMediumList(mediumList);
    setReligionList(religionList);
    setStateList(stateList);
    setLanguage1_2new(language1_2);
    setAdditional(additional);
    setCompulsary(compulsary);
    setCompulsoryOne(compulsory_one);
    setCompulsoryTwo(compulsory_two);
    setCompulsoryThree(compulsory_three);

    setFormData((prev) => ({
      ...prev,
      category_choice: candidateData.studenT_EXAM_CATEGORY_DESCRIPTION || "",
      candidate_name: candidateData.candidatE_NAME || "",
      candidate_code: candidateData.candidatE_ID || "",
      gender: candidateData.gender || "",
      date_of_birth: candidateData.dob || "",
      fathers_name: candidateData.fatheR_NAME || "",
      mothers_name: candidateData.motheR_NAME || "",
      religion: candidateData.religion || "",
      caste_val: candidateData.cast || "",
      divyang_val: candidateData.divyang || "",
      board_name: candidateData.boarD_NAME || "",
      examination_medium: candidateData.mediuM_OF_EXAM || "",

      // Subjects (Code + Name)
      language_one: candidateData.subjecT_1_CODE || "",
      language_one_name: candidateData.subjecT_NAME1 || "",

      language_two: candidateData.subjecT_2_CODE || "",
      language_two_name: candidateData.subjecT_NAME2 || "",

      compulsory_one: candidateData.subjecT_3_CODE || "",
      compulsory_one_name: candidateData.subjecT_NAME3 || "",

      compulsory_two: candidateData.subjecT_4_CODE || "",
      compulsory_two_name: candidateData.subjecT_NAME4 || "",

      compulsory_three: candidateData.subjecT_5_CODE || "",
      compulsory_three_name: candidateData.subjecT_NAME5 || "",

      additional_subject: candidateData.subjecT_6_CODE || "",
      additional_subject_name: candidateData.subjecT_NAME6 || "",

      // Other Identifiers
      pen_no: candidateData.peN_NO || "",
      apaar_id: candidateData.apaaR_ID || "",
    }));

    setPhotoName(candidateData.studenT_PHOTOGRAPH || "");
    setPhotooriginalname(candidateData.studenT_PHOTOGRAPH || "");
    setSignoriginalname(candidateData.studenT_SIGNATURE || "");
    setSignName(candidateData.studenT_SIGNATURE || "");
    setCasteName(candidateData.castE_CERTIFICATE || "");
    setDivyangName(candidateData.divyanG_CERTIFICATE || "");
    setPhotourl(candidateData.studenT_PHOTOGRAPH_URL || "");
    setSignurl(candidateData.studenT_SIGNATURE_URL || "");
    setCasteurl(candidateData.castE_CERTIFICATE_URL || "");
    setDivyangurl(candidateData.divyanG_CERTIFICATE_URL || "");
    setOlddivyangFile(candidateData.divyanG_CERTIFICATE || "");
    setLoading(false);
  }, [candidateData]);

  const handleChange = (e) => {
    const { name, value = "" } = e.target;

    let formattedValue = value;

    // Convert these fields to UPPERCASE
    if (
      name === "candidate_name" ||
      name === "fathers_name" ||
      name === "mothers_name"
    ) {
      formattedValue = value.toUpperCase();
    }

    setFormData((prev) => ({
      ...prev,
      [name]: formattedValue,
    }));

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handlePreview = async () => {
    setIsAgreed(false);
    setLoading(true);
    const trimmed = (val) => (val || "").trim();


    const newErrors = {};
    if (!formData.candidate_name) {
      newErrors.candidate_name = "Candidate name is required.";
    }
    if (!formData.fathers_name) {
      newErrors.fathers_name = "Father name is required.";
    }
    if (!formData.mothers_name) {
      newErrors.mothers_name = "Mother name is required.";
    }
    if (!formData.date_of_birth) {
      newErrors.date_of_birth = "Date of birth is required.";
    }

    setErrors(newErrors);
    const noErrors = Object.keys(newErrors).length === 0;

    if (!noErrors) {
      const firstErrorKey = Object.keys(newErrors)[0];
      const firstErrorElement = document.querySelector(
        `[name="${firstErrorKey}"]`
      );
      if (firstErrorElement) {
        firstErrorElement.focus();
      }
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
      setIsPreviewed(true);
    }
    setLoading(false);
  };
  const handleButtonClick = () => {
    handleSubmit();
  };
  const handleSubmit = async () => {
    const token = sessionStorage.getItem("secondaryAdminToken");

    if (!isAgreed) {
      await Swal.fire({
        icon: "warning",
        title: "Please Agree",
        text: "You must agree before submitting the form.",
      });
      return;
    }



    const fd = new FormData();

    fd.append("candidatE_CODE", candidateData.candidatE_ID || "");
    fd.append("REGISTRATION_NO", candidateData.refferencE_NO || "");
    fd.append("GENDER", formData.gender || "");
    fd.append("UPDATE_BY", sessionStorage.getItem("schoolCode") || "");

    try {
      const response = await fetch(
        `${config.API_BASE_URL2}/AdminUpdateDataStudentGender_CL10`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: fd,
        }
      );

      const data = await response.json();

      if (response.ok) {
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: "Gender updated successfully",
        });

        navigate("/secondary-Gender-details-update");
      } else {
        await Swal.fire({
          icon: "error",
          title: "Submission Failed",
          text: data.message || "Something went wrong.",
        });
      }
    } catch (error) {
      console.error("API Error:", error);
      await Swal.fire({
        icon: "error",
        title: "Network Error",
        text: "Please check your internet connection.",
      });
    }
  };

  const handlePenBlur = async () => {
    const rawPen = formData.pen_no?.trim();
    if (rawPen) {
      const penno = rawPen.replace(/\s/g, "");

      if (!penno || penno.length < 11 || penno.length > 14) return;

      const token = sessionStorage.getItem("secondaryAdminToken");

      try {
        const response = await fetch(
          `${config.API_BASE_URL2}/PENNoCheckingStudentData_CL10`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              candidatE_ID: candidateData.candidatE_ID || "",
              peN_NO: penno,
            }),
          }
        );

        const result = await response.json();

        if (result.status === 404) {
          Swal.fire({
            icon: "warning",
            title: "PEN(Permanent Education Number) No. Already Exists.",
            // text: "Aadhaar Number Already Exists.",
          });
          setFormData((prev) => ({
            ...prev,
            pen_no: "",
          }));

          return;
        }
        // console.log("Aadhaar verification result:", result);
      } catch (error) {
        console.error("Error verifying PEN No.", error);
      }
    }
  };

  const handleEditClick = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to edit this profile?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Edit",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        setIsEditMode(false);
        setIsPreviewed(false);
      }
    });
  };

  const handleContinueClick = async () => {
    if (!isAgreed) {
      await Swal.fire({
        icon: "warning",
        title: "Please Agree",
        text: "You must agree before submitting the form.",
      });
      return;
    }
    if (isEditMode === false) {
      finaledit(true);
      navigate("/class-x-upload-document");
    } else {
      navigate("/class-x-upload-document");
    }
  };



  const handleChangeDate = (date) => {
    if (date) {
      const dd = String(date.getDate()).padStart(2, "0");
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const yyyy = date.getFullYear();

      setFormData((prev) => ({
        ...prev,
        date_of_birth: `${dd}-${mm}-${yyyy}`,
      }));
    } else {
      setFormData((prev) => ({ ...prev, date_of_birth: "" }));
    }
  };

  return (
    <>
      {loading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}
      <div class="container-scroller">
        <Navbar />
        <div class="container-fluid page-body-wrapper">
          <Sidebar />
          <div class="main-panel">
            <div class="content-wrapper">
              <div class="row">
                <div class="col-md-12 mb-1">
                  <section class="content-header">
                    <h1>
                      <i class="fa fa-user-plus"></i>&nbsp; Student Gender Change for Class X{" "}
                      <span
                        className="text-danger"
                        style={{ fontWeight: "600" }}
                      >
                        [
                        {candidateData.studenT_CURRENT_STATUS?.toUpperCase() ||
                          ""}
                        ]
                      </span>
                    </h1>
                    <ol class="breadcrumb">
                      <li>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate("/secondary-admin-dashboard");
                          }}
                        >
                          <svg
                            stroke="currentColor"
                            fill="currentColor"
                            stroke-width="0"
                            viewBox="0 0 512 512"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{ marginTop: "-4px" }}
                          >
                            <path d="M256 64C132.3 64 32 164.2 32 287.9c0 57 21.3 109 56.3 148.5 1.1 1.2 2.1 2.4 3.2 3.5C96.3 445 103 448 110 448c7.1 0 13.8-3 18.6-8.2 31.6-34.4 77-55.9 127.4-55.9s95.8 21.6 127.4 55.9c4.8 5.2 11.5 8.2 18.6 8.2 7 0 13.7-2.9 18.5-8.1 1.1-1.2 2.1-2.3 3.2-3.5 35-39.5 56.3-91.5 56.3-148.5C480 164.2 379.7 64 256 64zm-14 45.9c0-7.7 6.3-14 14-14s14 6.3 14 14v36c0 7.7-6.3 14-14 14s-14-6.3-14-14v-36zm-128 192H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm51.5-104.5c-5.4 5.4-14.4 5.4-19.8 0L120.2 172c-5.4-5.4-5.4-14.4 0-19.8s14.4-5.4 19.8 0l25.5 25.5c5.4 5.4 5.4 14.3 0 19.7zm160.6 34.5l-47.5 75.5c-1.9 2.6-4.3 5.1-7 7-13.5 9.7-32.3 6.5-42-7s-6.5-32.3 7-42l75.5-47.5c3.4-2.4 8.1-2.5 11.7 0 4.5 3.2 5.5 9.5 2.3 14zm40.2-34.5c-5.4 5.4-14.4 5.4-19.8 0s-5.4-14.4 0-19.8l25.5-25.5c5.4-5.4 14.4-5.4 19.8 0s5.4 14.4 0 19.8l-25.5 25.5zM434 301.9h-36c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14z"></path>
                          </svg>{" "}
                          Home&nbsp;
                        </a>
                      </li>
                      <li class="active">  Gender Change for Class X</li>
                    </ol>
                  </section>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12 mb-4">
                  <div class="card">
                    <div class="card-header">
                      <h4 class="mb-0 p-2">Student Details</h4>
                    </div>
                    <div class="card-body">
                      <div class="row">

                        <div class="row">
                          <div class="col-lg-6 col-m-6">
                            <div class="form-group  mb-3">
                              <label>
                                Name of Student{" "}
                                <span class="text-danger">*</span>
                              </label>
                              <div class="input-group">
                                <input
                                  type="text"
                                  className={`form-control form-control-sm ${errors.candidate_name ? "is-invalid" : ""
                                    }`}
                                  onChange={handleChange}
                                  disabled
                                  name="candidate_name"
                                  value={formData.candidate_name}
                                />
                              </div>
                              {errors.candidate_name && (
                                <div className="text-danger mt-1 small">
                                  {errors.candidate_name}
                                </div>
                              )}
                            </div>
                          </div>
                          <div class="col-lg-3 col-m-6">
                            <div class="form-group  mb-3">
                              <label>Gender </label>
                              <select
                                className="form-select form-select-sm"
                                name="gender"
                                disabled={isPreviewed}
                                onChange={handleChange}
                                value={formData.gender?.toUpperCase()}
                              >
                                <option value="">Select</option>
                                <option value="MALE">MALE</option>
                                <option value="FEMALE">FEMALE</option>
                                <option value="TRANSGENDER">
                                  TRANSGENDER
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="col-lg-3 col-m-6">
                            <div class="form-group  mb-3">
                              <label>
                                Date of Birth{" "}
                                <span class="text-danger">*</span>
                              </label>
                              <DatePicker
                                selected={
                                  formData.date_of_birth
                                    ? (() => {
                                      const [dd, mm, yyyy] =
                                        formData.date_of_birth.split("-");
                                      return new Date(
                                        Number(yyyy),
                                        Number(mm) - 1,
                                        Number(dd)
                                      );
                                    })()
                                    : null
                                }
                                maxDate={new Date()}
                                onChange={handleChangeDate}
                                dateFormat="dd-MM-yyyy"
                                className={`form-control form-control-sm ${errors.date_of_birth ? "is-invalid" : ""
                                  }`}
                                placeholderText="dd-mm-yyyy"
                                disabled
                                onKeyDown={(e) => e.preventDefault()}
                                showYearDropdown
                                scrollableYearDropdown
                                yearDropdownItemNumber={60}
                              />

                              {errors.date_of_birth && (
                                <div className="text-danger mt-1 small">
                                  {errors.date_of_birth}
                                </div>
                              )}
                            </div>
                          </div>
                          <div
                            className={
                              formData.category_choice != "REGULAR"
                                ? "col-lg-6 col-md-6"
                                : "col-lg-4 col-md-4"
                            }
                          >
                            <div class="form-group  mb-3">
                              <label>
                                Father’s Name{" "}
                                <span class="text-danger">*</span>
                              </label>
                              <div class="input-group">
                                <input
                                  type="text"
                                  name="fathers_name"
                                  onChange={handleChange}
                                  disabled
                                  className={`form-control form-control-sm ${errors.fathers_name ? "is-invalid" : ""
                                    }`}
                                  value={formData.fathers_name}
                                />
                                {errors.fathers_name && (
                                  <div className="text-danger mt-1 small">
                                    {errors.fathers_name}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>

                          <div
                            className={
                              formData.category_choice != "REGULAR"
                                ? "col-lg-6 col-md-6"
                                : "col-lg-4 col-md-4"
                            }
                          >
                            <div class="form-group  mb-3">
                              <label>
                                Mother’s Name{" "}
                                <span class="text-danger">*</span>
                              </label>
                              <div class="input-group">
                                <input
                                  type="text"
                                  onChange={handleChange}
                                  name="mothers_name"
                                  disabled
                                  className={`form-control form-control-sm ${errors.mothers_name ? "is-invalid" : ""
                                    }`}
                                  value={formData.mothers_name}
                                />
                                {errors.mothers_name && (
                                  <div className="text-danger mt-1 small">
                                    {errors.mothers_name}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>

                        </div>


                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="card">
                    <div class="card-body">
                      <div className="row">
                        <div className="col-md-8">
                          {isPreviewed && (
                            <h5 style={{ color: "red" }}>
                              <input
                                type="checkbox"
                                checked={isAgreed}
                                onChange={(e) => setIsAgreed(e.target.checked)}
                              />{" "}
                              I AGREE THAT ALL THE INFORMATION GIVEN ABOVE IS
                              CORRECT AS PER MY BEST KNOWLEDGE.
                            </h5>
                          )}
                        </div>
                        <div
                          style={{ textAlign: "right" }}
                          className="col-md-4"
                        >
                          {isEditMode ? (
                            <>
                              <button
                                onClick={handleEditClick}
                                type="button"
                                className="btn btn-primary"
                              >
                                <i className="fa fa-edit me-1"></i> Edit
                              </button>
                              &nbsp;&nbsp;
                              <button
                                type="button"
                                onClick={handleContinueClick}
                                className="btn btn-success me-2"
                              >
                                Next <i className="fa fa-arrow-right me-1"></i>
                              </button>
                            </>
                          ) : isPreviewed ? (
                            <>
                              <button
                                onClick={handleButtonClick}
                                type="button"
                                className="btn btn-primary pull-right"
                              >
                                <i className="fa fa-save me-1"></i>
                                Submit
                              </button>
                              <button
                                type="button"
                                onClick={() => setIsPreviewed(false)}
                                className="btn btn-secondary me-2"
                              >
                                <i className="fa fa-edit me-1"></i> Edit
                              </button>
                            </>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-secondary me-2"
                              onClick={handlePreview}
                            >
                              <i className="fa fa-eye me-1"></i> Preview
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>

    </>
  );
}

export default StudentGenderChangeX;
